import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const FormLabel = ({ children, required = false, info, optional }) => {
  return (
    <p className="font13 capitalize">
      {children} {required && <span className="redColor">*</span>}
      {info && (
        <Tooltip title={info}>
          <InfoCircleOutlined
            className="lightColor"
            style={{ marginLeft: 5 }}
          />
        </Tooltip>
      )}
      {optional && <span className="lightColor thin font12">(optional)</span>}
    </p>
  );
};
